import { useForm } from 'react-hook-form';

import { SectionType } from 'sections/TabWrap';
import { EditForm, FormItem } from 'sections/EditForm';

const useData = () => {
  const { register } = useForm();

  const data: FormItem[] = [
    {
      name: 'name',
      value: '',
      label: 'Name',
    },
  ];

  const sections: SectionType[] = [
    {
      id: 1,
      content: <EditForm onSubmit={() => null} data={data} register={register} />,
    },
  ];

  return {
    sections,
  };
};

export { useData };
